import type { IllustrationMap } from '@/components/Illustration/types'
import { CancelledErrorIcon } from '@/components/Icons/ErrorIcons/CancelledErrorIcon'

export const onventisIllustrations: Partial<IllustrationMap> = {
  'transaction-expired': { component: CancelledErrorIcon },
  'transaction-already-ended': { component: CancelledErrorIcon },
}
